<template>
    <div class="c-audition">
        <LayoutContent>
            <div class="c-audition-box">
                <TemplateHeader>
                    <TitleText type="dark">
                        <template v-slot:import>{{ $t("main:魔音效果") }}</template>
                        <template v-slot:right>{{ $t("main:试听，感受不一样的声音玩法") }}</template>
                    </TitleText>
                </TemplateHeader>
                <ul class="c-audition-button-list">
                    <audio ref="audio" :src="playingAudioUrl"></audio>
                    <li class="list-item" v-for="item in audioArr" :key="item.id">
                        <span @click="handlePlayMusic(item.id)" :class="['c-audition-button', { 'is-active': playingAudioIndex === item.id }]">
                            {{ item.title }}
                            <i class="c-icon-music">
                                <span class="path-space is-01"></span>
                                <span class="path-space is-02"></span>
                                <span class="path-space is-03"></span>
                                <span class="path-space is-04"></span>
                                <span class="path-space is-05"></span>
                            </i>
                        </span>
                    </li>
                </ul>
            </div>
        </LayoutContent>
    </div>
</template>

<script>
import LayoutContent from "@/components/UI/LayoutContent.vue";
import TitleText from "@/components/UI/TitleText.vue";
import TemplateHeader from "@/components/UI/TemplateHeader.vue";
import daji from "@/assets/music/daji.wav";
import liubei from "@/assets/music/liubei.wav";
import anuan from "@/assets/music/anuan.wav";
import female from "@/assets/music/female.wav";
import male from "@/assets/music/male.wav";

export default {
    name: "Audition",
    components: { LayoutContent, TitleText, TemplateHeader },
    data() {
        return {
            playingAudioIndex: "",
            playingAudioUrl: "",
            audioArr: [
                {
                    id: 0,
                    title: $t("main:妲已魔音"),
                },
                {
                    id: 1,
                    title: $t("main:刘备魔音"),
                },
                {
                    id: 2,
                    title: $t("main:阿暖魔音"),
                },
                {
                    id: 3,
                    title: $t("main:新闻播报女"),
                },
                {
                    id: 4,
                    title: $t("main:新闻播报男"),
                },
            ],
            audioUrl: [daji, liubei, anuan, female, male],
        };
    },
    methods: {
        handlePlayMusic(index) {
            this.playingAudioUrl = this.audioUrl[index];

            // 点击的是当前播放的
            if (this.playingAudioIndex === index) {
                this.$refs.audio.pause();
                this.playingAudioIndex = "";
                return;
            }

            this.playingAudioIndex = index;
            this.$nextTick(function () {
                this.$refs.audio.play();
            });

            // 播放完成
            this.$refs.audio.addEventListener("ended", this.handeleClearAudio);
        },
        handeleClearAudio() {
            this.playingAudioIndex = "";
            this.playingAudioUrl = "";
        },
    },
    destroyed() {
        if (this.$refs.audio) {
            this.$refs.audio.removeEventListener("ended", this.handeleClearAudio);
        }
    },
};
</script>

<style scoped lang="less">
@import "/web/src/assets/css/theme.less";
.c-icon-music {
    display: none;
    align-items: center;
    justify-content: space-between;
    width: 54px;
    height: 42px;
    position: absolute;
    right: 8px;
    top: 0;
    bottom: 0;
    margin: auto;
    .path-space {
        display: inline-block;
        width: 6px;
        height: 40%;
        border-radius: 99px;
        background-color: rgba(102, 155, 255, 0.16);
        &.is-01,
        &.is-05 {
            height: 30%;
            -webkit-animation: is0105 0.8s infinite linear;
        }
        &.is-02,
        &.is-04 {
            height: 70%;
            -webkit-animation: is0204 0.8s infinite linear;
        }
        &.is-03 {
            height: 100%;
            -webkit-animation: is03 0.8s infinite linear;
        }
    }
}
@keyframes is0105 {
    0% {
        height: 30%;
    }
    50% {
        height: 70%;
    }
    25% {
        height: 40%;
    }
    100% {
        height: 30%;
    }
}
@keyframes is0204 {
    0% {
        height: 70%;
    }
    25% {
        height: 100%;
    }
    50% {
        height: 40%;
    }
    100% {
        height: 70%;
    }
}
@keyframes is03 {
    0% {
        height: 100%;
    }
    25% {
        height: 40%;
    }
    100% {
        height: 100%;
    }
}
.c-audition {
    padding: 24px;
    background: #151829 url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/product/bg-audition.png) no-repeat center bottom;
    background-size: 1920px;
    position: relative;
    &::after {
        content: "";
        position: absolute;
        left: 0;
        right: 64px;
        top: 0;
        bottom: 22%;
        margin: auto;
        width: 100%;
        max-width: 1344px;
        background: url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/product/img-audition.png) no-repeat center center;
        background-size: 1344px;
    }
}
.c-audition-box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 740px;
    padding-bottom: 104px;
}
.c-audition-button-list {
    display: flex;
    margin-left: -37px;
    margin-right: -37px;
    position: relative;
    z-index: 4;
    .list-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 37px;
        padding-right: 37px;
    }
}
.c-audition-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 180px;
    height: 56px;
    border: 1px solid #fff;
    border-radius: 8px;
    font-size: 24px;
    line-height: 1;
    color: #fff;
    cursor: pointer;
    position: relative;
    &.is-active {
        border: none;
        background-image: (linear-gradient(to right, #4e8cff, #415cf9));
        .c-icon-music {
            display: inline-flex;
        }
    }
    &:not(.is-active) {
        transition: ease-in-out 0.16s;
        &:hover {
            color: @primary-color;
            border-color: @primary-color;
            transition: ease-in-out 0.16s;
        }
    }
}
@media only screen and (max-width: 1200px) {
    .c-audition-button-list {
        padding: 0 24px;
        margin: 0;
        .list-item {
            padding-left: 16px;
            padding-right: 16px;
        }
    }
    .c-audition-button {
        max-width: 100%;
        height: 48px;
        border-radius: 6px;
        font-size: 18px;
        &.is-active {
            &::after {
                background: url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/product/bg-button-audition.png) no-repeat right center;
                background-size: auto 32px;
            }
        }
    }
    .c-audition-box {
        min-height: 560px;
        padding-bottom: 64px;
    }
    .c-audition {
        &:after {
            bottom: 8%;
            background-size: 100%;
        }
    }
    .c-icon-music {
        transform: scale(0.8);
    }
}
@media only screen and (max-width: 768px) {
    .c-audition-button-list {
        flex-wrap: wrap;
        .list-item {
            flex: unset;
            width: 33.333333%;
            padding: 8px 16px;
        }
    }
    .c-audition-box {
        min-height: 480px;
        padding-bottom: 32px;
        font-size: 16px;
    }
    .c-audition-button {
        &.is-active {
            &::after {
                background: url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/product/bg-button-audition.png) no-repeat right center;
                background-size: auto 24px;
            }
        }
    }
    .c-icon-music {
        right: 4px;
        transform: scale(0.72);
    }
}
@media only screen and (max-width: 480px) {
    .c-audition-button-list {
        margin: 0 -24px;
        .list-item {
            padding: 8px 12px;
        }
    }
    .c-audition-box {
        min-height: 400px;
    }
    .c-audition-button {
        height: 32px;
        border-radius: 4px;
        font-size: 14px;
    }
    .c-icon-music {
        right: 0;
        transform: scale(0.64);
    }
}
</style>
